import ProdutosClienteDetalhesViewModel from "@/shared/view-models/ProdutosClienteDetalhesViewModel";
import novaEmbalagemViewModel from "@/shared/view-models/Filtros/NovaEmbalagemViewModel";
import Tools from "@/shared/services/tools";
import ProdutoController from "@/shared/controllers/produto/produtoController";

const name = 'DetalhesProdutosCliente'


export default {
  name,

  components: { }, 

  props: { },

  mounted () { 
  if (this.orcamentoId) {
      this.OrcamentoSelecionado = this.orcamentoId;
    } else {
      this.OrcamentoSelecionado = this.$route.params.id;
    }
    
    this.getDadosECriticas()
    this.getComponentes()
    this.getEmbalagemColetiva()
    this.RotaImagem()
  },

  updated () {
    if (this.orcamentoId === "") {
      return;
    }
    if (this.orcamentoId) {
      this.OrcamentoSelecionado = this.orcamentoId;
    } else {
      this.OrcamentoSelecionado = this.$route.params.id;
    }
   },

  data () {
    return { 
      dataUltimaVendaFormatada: null,
      dataUltimoFaturamentoFormatada: null,
      DesabilitaCheckBox: false,
      novaEmbalagem : new novaEmbalagemViewModel(),
      embalagensArray:[],
      emLinha: null,
      fsc: null,
      InformacaoOrcamentoComponenteArray: [],
      ipi: null,
      nomeEmpresa: null,
      nomeFantasia: null,
      nomeProduto: null,
      observacaoGeral: '',
      codigoProduto:'',
      codigoExterno:'',
      componentesLista: "",
      OrcamentoCritica1: null,
      OrcamentoCritica2: null,
      OrcamentoCritica3: null,
      OrcamentoCritica4: null,
      OrcamentoCritica5: null,
      contemComponentes: false,
      OrcamentoSelecionado: null,
      OrcamentoId: null,
      ProdutosCliente: new ProdutosClienteDetalhesViewModel(),
      styleImg: '',

    }
  },

  methods: { 
    RotaImagem(){
      /*eslint-disable*/
      ProdutoController.GetRotaImagemProdutoByProdutoId(this.$route.params.id).requisicao
      .then(res => {
        const urlBase = window.location.host
        if(res.data.data === 'erro'){
          this.erro(undefined)
          return
        }

        this.caminhoImagem = `http://${urlBase}/${res.data.data}`;
        // this.caminhoImagem = `https://fdv.grupojauense.com.br/${res.data.data}`;

        this.styleImg = 'width: 400px'

      })
    },
    erro(e){
      if(e == undefined){
        this.caminhoImagem = 'http://' + window.location.host + '/repositorio/Ilustracao_Nenhuma_Img.svg'
        this.styleImg = 'width: 100px'
      }
    },
    retornaTelaProdutosCliente () {
      this.$router.push(`/produtos-cliente`)
    },
    
    getDadosECriticas() {
      this.$isLoading(true)
      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + `Produto/DadosDoProdutoPorCliente/${this.$route.params.id}`,
      })
        .then((response) => {
          this.nomeEmpresa = response.data.data.nomeEmpresa
          this.nomeProduto = response.data.data.nomeProduto
          this.nomeFantasia = response.data.data.nomeFantasia
          this.codigoProduto = response.data.data.codigoProduto
          this.codigoExterno = response.data.data.codigoExterno
          this.ipi = response.data.data.ipi
          this.dataUltimaVendaFormatada = response.data.data.dataUltimaVendaFormatada
          this.dataUltimoFaturamentoFormatada = response.data.data.dataUltimoFaturamentoFormatada
          this.emLinha = response.data.data.emLinhaTexto
          this.fsc = response.data.data.fscTexto
          this.observacaoGeral = response.data.data.observacaoGeral
          this.OrcamentoId = response.data.data.orcamentoId,
          // this.InformacoesOrcamentoComponenteByOrcamentoId()

          this.OrcamentoCritica1 = response.data.data.critica1
          this.OrcamentoCritica2 = response.data.data.critica2
          this.OrcamentoCritica3 = response.data.data.critica3
          this.OrcamentoCritica4 = response.data.data.critica4
          this.OrcamentoCritica5 = response.data.data.critica5

          this.RotaImagem()
        })
        .finally(()=> {
          this.$isLoading(false)
        })
    },

    getComponentes() {
      this.axios({
        method: "get",
        url:
          process.env.VUE_APP_WEB_API +
          `Componente/GetComponentesByProdutoId/${this.OrcamentoSelecionado}`,
      })
        .then((response) => {
          if(response.data.data == [])
          {
            this.contemComponentes = false
          }
          else{
            this.componentesLista = response.data.data;
            this.contemComponentes = true
            // this.componentesLista.forEach((r)=>{
            //   r.colunaMedidas = `${r.numeroComprimento} x ${r.numeroLargura} x  ${r.numeroAltura} x ${r.numeroAlturaTampa}`
            //   })
            this.embalagensEspecificas()
          }
          console.log(this.componentesLista)

          this.getParametros();
        })
        .catch(() => {});
    },

    InformacoesOrcamentoComponenteByOrcamentoId() {
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `OrcamentoComponente/GetOrcamentoComponenteProdutoNovoByOrcamentoId/${this.OrcamentoId}`,
      })
      .then((response) => {
        this.InformacaoOrcamentoComponenteArray = response.data.data
        this.novaEmbalagem = response.data.data
        this.embalagensEspecificas()


        this.InformacaoOrcamentoComponenteArray.forEach((r)=>{
          // r.ColunaMedidas = `${r.numeroComprimento} x ${r.numeroLargura} x  ${r.numeroAltura} x ${r.numeroAlturaTampa}`
          r.CoresFrente = r.descCoresFrenteEnum ? `${r.descCoresFrenteEnum} / ${r.nomeCorFrente} ${r.quantidadeCoresFrente}` : `${r.descCoresFrenteEnum} / Sem Impressão`
          r.CoresVerso = r.descCoresVersoEnum ? `${r.descCoresVersoEnum} / ${r.nomeCorVerso} ${r.quantidadeCoresVerso}` : `${r.descCoresVersoEnum} / Sem Impressão`
          r.GramaturaCapaInterna = r.descCapaInternaEnum ? `${r.descCapaInternaEnum} ${r.numeroGramaturaCapaInterna}` : `` 
          r.GramaturaCapaExterna = r.descCapaExternaEnum ? `${r.descCapaExternaEnum} ${r.numeroGramaturaCapaExterna}` : ``
          r.GramaturaPapelOnda = r.descPapelOndaEnum ? `${r.descPapelOndaEnum} ${r.numeroGramaturaPapelOnda}` : ``
          r.EmbalagemColetiva = r.descEmbalagemColetiva ? `Caixa coletiva - ${r.quantidadeCaixaColetiva}` : r.descEmbalagemColetiva ? `Filme encolhível - ${r.quantidadeFilmeEncolhivel}` : r.descEmbalagemColetiva ? `Palete - ${r.quantidadePalete}` : `Outros - ${r.quantidadeOutros}`
          r.codigoSistema = r.descSistemaEnum ? 'Escolha conforme tabela' : ''        

        this.DesabilitaCheckBox = true
        })
      })
      .catch(() => {
      });
    },

    getEmbalagemColetiva() {
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Componente/GetComponentesByProdutoId/${this.$route.params.id}`,
      })
        .then((response) => {
          Tools.objectCustomAssign(this.componentesLista, Tools.captalizeKeys(response.data.data))
          // this.OrcamentoId = this.novaEmbalagem.OrcamentoId;  TODO


          this.InformacoesOrcamentoComponenteByOrcamentoId();
        })
    },

    embalagensEspecificas(){
        this.componentesLista.forEach((r)=>{
          r.embalagens = []
          r.embalagemEspecificaFilmeEncolhivel == true ? r.embalagens.push('Filme encolhível - ' + `${r.quantidadeFilmeEncolhivel}`) : ''
          r.embalagemEspecificaCaixaColetiva == true  ? r.embalagens.push('Caixa Coletiva - ' + `${r.quantidadeCaixaColetiva}`) : ''
          r.embalagemEspecificaPalete == true  ? r.embalagens.push('Palete - ' + `${r.quantidadePalete}`) : ''
          r.embalagemEspecificaPapelEmbrulho == true  ? r.embalagens.push('Papel Embrulho - ' + `${r.quantidadeFilmeEncolhivel}`) : ''
          r.quantidadeOutros > 0 ? r.embalagens.push( r.descricaoEmbalagemOutros != null || r.descricaoEmbalagemOutros != '' ?  r.descricaoEmbalagemOutros+ " - " + `${r.quantidadeOutros}`  : 'Outros - ' + `${r.quantidadeOutros}`) : ''
    })
    },

   },

  computed: { }, 

};